import { Libraries, useJsApiLoader } from "@react-google-maps/api";
import { googleMapDarkModeId, googleMapId, googleMapKey } from "common/config";

const mapLibraries: Libraries = ["geometry"];

export function useLoadGoogleMaps() {
  const { isLoaded } = useJsApiLoader({
    id: "google-maps-script",
    mapIds: [googleMapDarkModeId, googleMapId],
    googleMapsApiKey: googleMapKey,
    libraries: mapLibraries,
    version: "3.55",
  });

  return {
    isMapsLoaded: isLoaded,
  };
}
